export default __webpack_public_path__ + "static/sheephostingbay-web-hosting-services-d1eb30039267875b1a9eab032f649f9b.png";